export default "__VITE_ASSET__9AGQrcHM__"